import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SupportAction } from './SupportAction';
import styles from './AsyncState.module.css';
export function UnavailablePage() {
  const { t } = useTranslation();
  return <section className={styles.error}><h2>{t('ui.unavailablePage.title')}</h2>
    <p>{t('ui.unavailablePage.hint')}</p><Link to="/">{t('ui.unavailablePage.goHome')}</Link><SupportAction />
  </section>;
}
